// Read-only identity derived from the server-assigned ID. Cloning a label receives
// a new ID, so copying meta cannot accidentally duplicate the public number.
export function labelMetaOf(label) {
  const raw = label?.meta ?? label?.metaJson;
  if (typeof raw === 'string') { try { return JSON.parse(raw) || {}; } catch { return {}; } }
  return raw && typeof raw === 'object' ? raw : {};
}
export const labelCreatedAt = label => label?.createTime || label?.createdAt || '';
export function labelNumber(label) {
  const id = label?.id ?? label?.labelId;
  if (id == null || !/^\d+$/.test(String(id))) return '';
  const time = labelCreatedAt(label);
  const date = time ? new Date(time) : null;
  // Use the system's China timezone, independent of the viewer's timezone.
  const year = date && Number.isFinite(date.getTime())
    ? new Date(date.getTime() + 8 * 60 * 60 * 1000).getUTCFullYear() : 'ID';
  return `HPBIO-DL-${year}-${String(id).padStart(6, '0')}`;
}
export function labelChanges(label) {
  const trace = labelMetaOf(label).labelTrace;
  if (!trace || String(trace.labelId) !== String(label?.id ?? label?.labelId)) return [];
  return Array.isArray(trace.changes) ? trace.changes.filter(change => typeof change?.reason === 'string') : [];
}
export const latestChangeReason = label => labelChanges(label).slice(-1)[0]?.reason || '';
export function changeReasonError(reason) {
  if (!String(reason || '').trim()) return '请填写本次修改原因';
  if (String(reason).trim().length > 500) return '修改原因不能超过500字';
  return '';
}
export function withLabelChange(meta, label, reason, at = new Date().toISOString()) {
  const error = changeReasonError(reason);
  if (error) throw new Error(error);
  const id = label?.id ?? label?.labelId;
  if (id == null) throw new Error('缺少标签ID，无法记录修改原因');
  return { ...meta, labelTrace: { schemaVersion: 1, labelId: String(id),
    changes: [...labelChanges(label), { reason: reason.trim(), at }] } };
}
export function labelRevision(label) {
  if (!Array.isArray(label?.contentItems)) return '';
  const ordered = value => Array.isArray(value) ? value.map(ordered) :
    value && typeof value === 'object' ? Object.fromEntries(Object.keys(value).sort().map(key => [key, ordered(value[key])])) : value;
  const parse = value => { if (typeof value !== 'string') return value; try { return JSON.parse(value); } catch { return value; } };
  // QR generation also changes updateTime. Compare actual content, not that clock.
  return JSON.stringify(ordered({
    labelName: label.labelName, backgroundImage: label.backgroundImage || null,
    backgroundColor: label.backgroundColor, borderColor: label.borderColor,
    meta: labelMetaOf(label),
    contentItems: label.contentItems.map(item => ({ type: item.contentType || item.type,
      data: parse(item.contentData ?? item.data), order: item.sortOrder }))
  }));
}
